/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

import { Layout } from '@/data/types/Layout';

export const getDashboardPage = (): Layout => ({
	name: 'MyPages',
	slots: {
		header: [{ name: 'Header', id: 'header' }],
		first: [{ name: 'Dashboard', id: 'dashboard' }],
		aside: [],
		second: [],
		third: [],
		footer: [{ name: 'Footer', id: 'footer' }],
	},
});
